import { createContext, useContext, useState } from 'react'

// Create the context
const PanelContext = createContext<{
  isSelectOpen: boolean
  setIsSelectOpen: (open: boolean) => void
} | null>(null)

/**
 * Panel provider to manage the state of the custom panel passed to DataGrid
 */
export function PanelProvider({ children }: { children: React.ReactNode }) {
  const [isSelectOpen, setIsSelectOpen] = useState(false)

  return (
    <PanelContext.Provider value={{ isSelectOpen, setIsSelectOpen }}>
      {children}
    </PanelContext.Provider>
  )
}

// Hook that won't throw if used outside context
export function usePanelContext() {
  return useContext(PanelContext)
}
